export default {
	unexpectedError: "Unexpected error: {message}",
	createSuccessNotification: "New goal created.",
	createErrorNotification: "Error creating goal: {message}",
	saveSuccessNotification: "Goal saved.",
	saveErrorNotification: "Error saving goal: {message}",
	deleteSuccessNotification: "Goal deleted.",
	deleteErrorNotification: "Error deleting goal: {message}",
	archiveSuccessNotification: "Goal archived.",
	archiveErrorNotification: "Error archiving goal: {message}",
	unarchiveSuccessNotification: "Goal unarchived.",
	unarchiveErrorNotification: "Error unarchiving goal: {message}",
	createCommentSuccessNotification: "Comment saved.",
	createCommentErrorNotification: "Error saving comment: {message}",

	externalChangeNotification: "This goal has been updated by someone else. Please refresh the page to see changes.",
};
